var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-6669 -701 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-1 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2409",
    "data-name": "Gruppe 2409",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2405",
    "data-name": "Gruppe 2405",
    transform: "translate(-7084 -706.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_167",
    "data-name": "Pfad 167",
    className: "cls-1",
    d: "M462.4,51a1.58,1.58,0,0,1-1.6,1.6H440a1.58,1.58,0,0,1-1.6-1.6V30.2a1.58,1.58,0,0,1,1.6-1.6h20.8a1.58,1.58,0,0,1,1.6,1.6Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_23",
    "data-name": "Linie 23",
    className: "cls-1",
    y2: 6.4,
    transform: "translate(449.6 22.2)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_24",
    "data-name": "Linie 24",
    className: "cls-1",
    y2: 6.4,
    transform: "translate(443.2 22.2)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_25",
    "data-name": "Linie 25",
    className: "cls-1",
    y2: 6.4,
    transform: "translate(457.6 22.2)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_26",
    "data-name": "Linie 26",
    className: "cls-1",
    x2: 6.4,
    transform: "translate(432 41.4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_27",
    "data-name": "Linie 27",
    className: "cls-1",
    x2: 6.4,
    transform: "translate(432 47.8)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_28",
    "data-name": "Linie 28",
    className: "cls-1",
    x2: 6.4,
    transform: "translate(432 33.4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_29",
    "data-name": "Linie 29",
    className: "cls-1",
    y1: 6.4,
    transform: "translate(451.2 52.6)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_30",
    "data-name": "Linie 30",
    className: "cls-1",
    y1: 6.4,
    transform: "translate(457.6 52.6)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_31",
    "data-name": "Linie 31",
    className: "cls-1",
    y1: 6.4,
    transform: "translate(443.2 52.6)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_32",
    "data-name": "Linie 32",
    className: "cls-1",
    x1: 6.4,
    transform: "translate(462.4 39.8)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_33",
    "data-name": "Linie 33",
    className: "cls-1",
    x1: 6.4,
    transform: "translate(462.4 33.4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_34",
    "data-name": "Linie 34",
    className: "cls-1",
    x1: 6.4,
    transform: "translate(462.4 47.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_168",
    "data-name": "Pfad 168",
    className: "cls-1",
    d: "M459.2,46.2a3.159,3.159,0,0,1-3.2,3.2H444.8a3.159,3.159,0,0,1-3.2-3.2V35a3.159,3.159,0,0,1,3.2-3.2H456a3.159,3.159,0,0,1,3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_35",
    "data-name": "Linie 35",
    className: "cls-1",
    x2: 6.4,
    transform: "translate(446.4 36.6)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_36",
    "data-name": "Linie 36",
    className: "cls-1",
    x2: 3.2,
    transform: "translate(446.4 39.8)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_37",
    "data-name": "Linie 37",
    className: "cls-1",
    x2: 3.2,
    transform: "translate(451.2 44.6)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1326",
    "data-name": "Rechteck 1326",
    className: "cls-2",
    width: 60,
    height: 60,
    transform: "translate(-6664 -696)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter2);
export default __webpack_public_path__ + "static/media/filter2.97718cb335e2628529f2ac6695667d74.svg";
export { ForwardRef as ReactComponent };